import { render, staticRenderFns } from "./addPersonEditNew.vue?vue&type=template&id=40061ce5&scoped=true"
import script from "./addPersonEditNew.vue?vue&type=script&lang=js"
export * from "./addPersonEditNew.vue?vue&type=script&lang=js"
import style0 from "./addPersonEditNew.vue?vue&type=style&index=0&id=40061ce5&prod&lang=scss&scoped=true"
import style1 from "./addPersonEditNew.vue?vue&type=style&index=1&id=40061ce5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40061ce5",
  null
  
)

export default component.exports